export const CursorTypes = {
  DEFAULT: 'default',
  WAIT: 'wait',
};

export const changeCursorTo = cursorType => {
  document.body.style.cursor = cursorType;
};
